import { isNullOrEmpty } from "./string";
import { ERR_INVALID_STATE, newError } from "./error";
import { Log } from "./Log";
export function getDataPath() {
    if (isNullOrEmpty(wcfConfig.dataPath)) {
        throw newError(ERR_INVALID_STATE, "wcfConfig.dataPath not defined");
    }
    return (wcfConfig.dataPath);
}
//init default configuration
let localConfig = {
    configVersion: 2, //increase if interface has changed in an incompatible way
    articleConfigurationOptions: {
        highResPropValueIcons: true,
        fetchPropValueImages: false,
        trimPropText: true
    },
    ajaxDefaultOptions: {
        cache: true,
        dataType: "post",
        responseType: "auto",
        headers: {},
        user: "",
        password: "",
        withCredentials: false,
        timeout: 30000,
        retryAttempts: 3,
        ignoreGlobalErrorHandler: false
    },
    ajaxGetRetryDelay: (pRetryCount) => {
        return (pRetryCount * 200);
    }
};
//Register config in global scope. This makes it possible to share the configuration between multiple W-CF instances.
const GLOBAL_KEY = "egr_wcf_globalWcfConfig";
if (window[GLOBAL_KEY] == null) {
    //no other global config, use local as global
    window[GLOBAL_KEY] = localConfig;
}
else {
    //use global config if there is no version missmatch
    const globalConfig = window[GLOBAL_KEY];
    if (globalConfig.configVersion === localConfig.configVersion) {
        localConfig = globalConfig;
    }
    else {
        Log.warn("Can't share global wcfConfig because of incompatible versions.");
    }
}
/**
 * Global configuration for W-CF.
 */
export const wcfConfig = localConfig;
export default wcfConfig;
